export const zhCN = {
    home: "主页",
    intro:"介绍",
    visa:"签证",
    act:"活动",
    contact:"联系",
    language: "English",
    part1: {
        title: "公司简介",
        content: "艾勒盟特移民集团创建于2001年，作为知名墨尔本移民中介专业办理各类移民。自公司成立至今，我们秉着想客户之所想的工作理念，率先推出签证私人管家服务，为近万人提供了在澳洲生活和工作的机会,并协助客户成功融入澳洲社会。我们的目标是通过我们的签证私人管家，为客户量身定制切实可行的移民申请方案，帮助客户实现梦想。基于多年的办案经验和极高的成功率 ，在2013年澳洲梦移民集团总裁被澳洲移民协会授予行业最高荣誉——移民专家称号。"
    },
    part2: {
        title1:"18年专业移民经验",
        content1:"自成立以来，我们成功完成了数千件移民个案，为近万人提供了移民机会。",
        title2:"移民专家",
        content2:"我们拥有数位富有经验的移民代理，其中公司的创始人解献莉女士被澳洲移民协会授予行业最高荣誉——移民专家称号，成为澳洲首批20位专业移民代理。",
        title3:"极高的成功率",
        content3:"我们常年保持96%极高的成功率，是行业中的先驱，让我们帮助您成功完成移民梦想。"
    },
    part3: {
        title:"为什么选择艾勒盟特移民集团 ?",
        content1:"如果您是客户，我们可以提供：",
        content2:"14年数以千计的成功案例",
        content3:"私人定制的移民方案",
        content4:"与签证官直接探讨个案的能力",
        content5:"与各州政府良好的合作关系",
        content6:"贴心的后续服务，如贵族学校入学，别墅购置，投资理财等",
        content7:"便捷咨询以融入澳洲主流社会",
        content8:"公司26年创建的社交平台助您在澳洲拓展商机",
        content9:"在艾勒盟特，我们相信我们的服务不只于提供签证获取，我们更会为您融入澳大利亚文化提供全面的帮助"
    },
    part4: {
        title:"签证服务",
        content: "艾勒盟特移民集团提供以下各类签证服务，请点击相应板块了解更多移民信息。",
        part1:{
            title: "投资移民类",
            content1: '188A 商业创新类',
            content2: '188B 商业管理和投资类',
            content3: '188C 重大投资者类',
            content4: '132 商业天才类永居'
        },
        part2:{
            title: "雇主担保类",
            content1: '186 雇主担保移民类',
            content2: "482 临时技术短缺签证"
        },
        part3:{
            title: "技术移民类",
            content1: '189 独立技术移民签证',
            content2: "190 州政府担保技术移民签证"
        },
        part4:{
            title: "澳洲偏远地区移民类签证",
            content1: '491 边远地区技术临时签证',
            content2: '494 偏远地区雇主担保临时签证',
            content3: '191 偏远地区永居签证',
        },
        part5:{
            title: "家庭成员类移民",
            content1: '配偶移民',
            content2: "父母移民签证"
        },
        part6:{
            title: "其他签证",
            content1: '学生签证',
            content2: '探亲签证',
            content3: '商务签证',
        }
    },
    part5:{
        title: "联系方式",
        content1:"地址",
        content2:"电话",
        content3:"邮箱",
    },
    189:{
        title:"189 独立技术移民签证",
        content1:"此签证既可以在澳洲境内申请也可以在澳洲境外申请。它是之前175签证和885签证合并后的签证类型。申请成功后是一步到位的永居签证。",
        content2:`签证需求
                提名的职业在相关技能的职业列表上
                具有满足要求的职业技能评估
                年龄在50岁以下
                评分达到至少60分
                需要获得EOI 邀请（be invited to apply）
                雅思不低于4个6`
    },
    190:{
        title:"190 州政府担保技术移民签证",
        content1:"此签证既可以在澳洲境内申请也可以在澳洲境外申请。它是之前176签证和886签证合并后的签证类型。申请成功后是一步到位的永居签证。与189签证相比，190签证需要有州政府担保，移民成功后申请人需要到担保的州居住2年以后才可以去其他地区定居（有居住限制）。",
        content2:`签证需求
                提名的职业在相关技能的职业列表上
                具有满足要求的职业技能评估
                年龄在50岁以下
                有州政府担保
                评分达到至少55分，获得州担保5分后达到60分
                需要获得EOI 邀请（be invited to apply）
                雅思不低于4个6`
    },
    491:{
        title:"491 边远地区技术临时签证",
        content1:`紧缺职位较多，获邀率较高
                    相对名额充足，签证有效期长达5年，
                    在偏远地区生活和工作满三年后，可以申请永居`,
        content2:`签证需求
                签证申请递交时申请人年龄在45周岁以下
                提名职位在各州偏远地区职位清单上
                成功通过相关职业技术评估
                雅思成绩不低于各科6分
                EOI评分至少在65分以上
                获得偏远地区州政府担保/偏远地区亲属担保`
    },
    494:{
        title:"494偏远地区雇主担保临时签证",
        content1:`相对名额充足，签证有效期长达5年，
                在偏远地区生活和工作满三年后，可以申请永居`,
        content2:`签证需求
                签证申请递交时申请人年龄在45周岁以下
                提名职位在各州偏远地区职位清单上
                成功通过相关职业技术评估
                本科以上（或职业指定的）相关学历
                3年以上相关全职工作经验
                雅思成绩不低于各科6分
                获得偏远地区雇主担保的全职工作`
    },
    191:{
        title:"191偏远地区永居签证",
        content1:`可以在澳洲永久居住和生活
                在澳洲工作和上学不受区域限制
                可以担保其他符合条件的亲戚申请澳洲永居
                如果满足条件，申请澳洲公民`,
        content2:`签证需求
            在申请191签证时，需要持有至少三年的491或者494签证
            需要至少有三年最低相关收入
            主申请人和副申请人都需要满足偏远地区临时签证的签证条件`
    },
    A188:{
        title:"188A 商业创新类",
        content1:"具体适宜情况请咨询艾勒盟特移民集团",
        content2:
            `签证需求
            主申请人55岁以下
            有直接参与经营及管理企业的成功经历
            商业及个人净资产不低于80万澳币
            过去四个财政年中至少有2年
            企业营业额不低于50万澳币
            过去4年中申请人及配偶在企业需持股至少2年
            评分达到65分
            主副申请人可互换`
    },
    B188:{
        title:"188B 商业管理和投资类",
        content1:"具体适宜情况请咨询艾勒盟特移民集团",
        content2:`签证需求
                主申请人55岁以下
                至少3年直接参与公司管理或投资活动,
                投资活动金额不少于150万澳币,
                申请前2年商业净资产及个人净资产达到225万澳币, 
                申请人及配偶拥有10%企业所有权利益, 
                投资150万澳币到澳洲政府指定的债券中4年,
                评分达到65分`
    },
    C188:{
        title:"188C 重大投资者类",
        content1:`50万澳元投资在合规的澳大利亚风投或投资在增长的私募公司。这些私募公司须要投到新公司或者小型私人公司
                    150万澳元投资在合规的管理基金或者上市的投资公司 （LICs）。这些投资公司的投资项目需要投资在澳大利亚证券交易（ASX）所上所列出的新兴公司里
                    余下的300万澳元（Balancing Investment）须要投资在合规的管理基金或者投资公司。这些投资公司须要投资在合规的综合项目里，其中包括澳大利亚证券交易所的其他上市公司，符合条件的企业债券，年金和房地产（投资在住宅房地产中限制在投资公司所有投资金额的10%） `,
        content2:`签证需求
                无年龄限制，无英语要求，无需打分
                无商业背景及经商经验要求
                移民监超短，每年住满40天或4年内累计住满160天
                资产来源审理较其他商业签证宽松`
    },
    132:{
        title:"132 商业天才类永居",
        content1:"具体适宜情况请咨询艾勒盟特移民集团",
        content2:`签证需求
            主申请人55岁以下
            拥有一个成功的经商生涯
            申请人及配偶拥有不低于40万澳币的企业净资产
            申请人及配偶拥有企业股权
            申请人及配偶的全部资产至少达到150万澳币
            企业的营业额在过去四个财年中的两年达到至少300万澳币`
    },
    186:{
        title:"186 雇主担保移民类",
        content1:"具体适宜情况请咨询艾勒盟特移民集团",
        content2:`签证需求
                大专以上学历
                年龄50周岁以下
                雅思不低于4个6
                从事专业工作3年以上
                需要对学历和工作经验通过职业评估
                具有澳大利亚境内雇主提名`
    },
    482:{
        title:"482 临时技术短缺签证",
        content1:"此签证也叫做TSS签证，为了解决雇主对于本地澳洲劳工短缺的困难，而引进海外技工人员。此签证在保证本地澳洲劳工能够优先就业的前提下，允许雇主雇佣海外员工，来解决劳动力短缺的情况。TSS签证持有人，可以澳大利亚为他们的担保雇主从事他们被提名的工作。",
        content2:`签证流程
                雇主担保资质
                职位提名
                签证申请`
    },
    couple:{
        title:"配偶移民",
        content1:"配偶移民是以澳大利亚公民、永久居民或符合资格的新西兰公民的配偶身份，或潜在配偶身份（未婚妻或未婚夫）移民。",
        content2:"澳大利亚配偶移民的申请者必须同担保人有婚姻关系或者同居关系。如果以同居关系为基础申请，此关系必须在申请之前已经维持了至少12个月。以潜在配偶身份（未婚妻或未婚夫）申请，申请者必须在澳大利亚境外，已经同担保人订婚，并计划结婚。"
    },
    parent:{
        title:"父母移民签证",
        content1:"现有的父母移民签证分为两种，一种为“一般排队父母移民103签证”（Parent Visa)，其排队期为约25年。",
        content2:"另一种为“捐献金父母移民143签证”（Contributory Parent Visa），要求申请人支付澳大利亚政府相当的款项用于父母未来的健康医疗费用。捐献金父母移民又可以分成两类，一类是“捐献金父母永居143签证”，一类是“捐献金父母临时173签证”。“捐献金父母永居143签证”需要一次性支付所有捐献款项，“捐献金父母临时173签证”可以分2期支付所有捐献款项，在2年内付清余额后转成永居签证。捐献金额每年都有增长。"
    },
    student:{
        title:"学生签证",
        content1:"艾勒盟特移民集团可以办理从中学起的学生签证，提供择校建议，专业指南，职业测评，学校申请，签证材料准备，签证申请，签证辅导，离境辅导，境外服务等一条龙服务。",
        content2:"具体适宜情况请咨询艾勒盟特移民集团"
    },
    visit:{
        title:"探亲签证",
        content1:"帮助澳大利亚公民和永久居民的父母申请为期三至五年的旅游签证。",
        content2:"此签证允许申请者多次往返，每次的停留时间长达12个月。"
    },
    business:{
        title:"商务签证",
        content1:"我们为公司及个人办理商务签证，以商务目的赴澳，包括参加会议，考察投资项目等。",
        content2:"此签证最长三年有效，每次停留时间不超过3个月。"
    }
}